module.exports = {
	countryCodeToName: require('./countryCodeToName.json'),
    getSignature: require('./getSignature'),
    dictionaries: require('./dictionaries.json'),
	getTranslationDictionary: require('./getTranslationDictionary'),
    sendRequest: require('./sendRequest'),
    serviceUrl: require('./serviceUrl'),
};
